export enum StudentStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  GRADUATED = "GRADUATED",
  WITHDRAWN = "WITHDRAWN",
  TRANSFERRED_OUT = "TRANSFERRED_OUT"
}

export interface Student {
  id: string;
  companyId: string;
  studentCode: string;
  fullName: string;
  programId?: string | null;
  gradeId?: string | null;
  streamId?: string | null;
  studentCategoryId?: string | null;
  academicYearId?: string | null;
  billingPeriodId?: string | null;
  enrollmentDate?: string | null;
  guardianPhone?: string | null;
  guardianEmail?: string | null;
  status?: StudentStatus | null;
  version?: number | null;
}

export interface ListStudentsInput {
  search?: string;
  page?: number;
  size?: number;
}

export interface ListStudentsResponse {
  code: string;
  students?: Student[];
  totalElements?: number;
  totalPages?: number;
  currentPage?: number;
  pageSize?: number;
}

export interface GetStudentInput {
  studentId: string;
}

export interface GetStudentResponse {
  code: string;
  student?: Student;
}

export interface CreateStudentInput {
  studentCode: string;
  fullName: string;
  programId?: string;
  gradeId?: string;
  streamId?: string;
  studentCategoryId?: string;
  academicYearId?: string;
  billingPeriodId?: string;
  enrollmentDate?: string;
  guardianPhone?: string;
  guardianEmail?: string;
  status?: StudentStatus;
}

export interface CreateStudentResponse {
  code: string;
  student?: Student;
}

export interface UpdateStudentInput {
  studentId: string;
  updates: Partial<CreateStudentInput>;
  expectedVersion?: number;
}

export interface UpdateStudentResponse {
  code: string;
  student?: Student;
}

export interface StudentExitInput {
  studentId: string;
  expectedVersion?: number;
  reason?: string;
}
